// extracted by mini-css-extract-plugin
export default {"rightPanelWrapper":"UKIfvHS","activityBarWrapper":"v4MPvyb"};